import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input, OnInit,
  OnChanges,
  Output,
  SimpleChanges, ViewChild, DoCheck, ElementRef, OnDestroy, Renderer2, RendererStyleFlags2, HostListener,
  ChangeDetectorRef
} from "@angular/core";
import {VisitPlanModel} from "../../../models/visit-plan.model";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import * as moment from "moment";
import {VisitPlanAccountModel} from "../../../models/visit-plan-account.model";
import {VisitPlanCellModel} from "../../../models/visit-plan-cell.model";
import {VisitPlanCallModel} from "../../../models/visit-plan-call.model";
import {VisitScheduleDayModel} from "../../../models/visit-schedule-day.model";
import {isVisitScheduleDayDispatched} from "../../../models/visit-schedule-day.functions";
import {VisitPlanDayTotalsModel} from "../../../models/visit-plan-day-totals.model";
import {VisitPlanAccountAnalysisModel} from "../../../models/visit-plan-account-analysis.model";
import * as _ from "lodash";

require('./visit-plan-accounts-table.scss');
@Component({
  standalone: false,
  selector: 'app-visit-plan-accounts-table',
  templateUrl: './visit-plan-accounts-table.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitPlanAccountsTableComponent implements OnInit, OnChanges, AfterViewInit, DoCheck, OnDestroy {

  @Input() accounts: VisitPlanAccountModel[];
  @Input() isInitialized: boolean;
  @Input() visitPlanDayTotals: VisitPlanDayTotalsModel[];
  @Input() visitPlanInitialDayTotals: VisitPlanDayTotalsModel[];
  @Input() visitPlanAccountsAnalysis: VisitPlanAccountAnalysisModel[];
  @Input() visitPlan: VisitPlanModel;
  @Input() from: number;
  @Input() to: number;
  @Input() programTypeAliasMap: { [key: string]: string };
  @Input() checkViewportSize: number;
  @Input() isImporting: boolean;
  @Input() visitScheduleDays: VisitScheduleDayModel[];
  @Input() tableFilterColumns: { isDisplayDeliveryEtd: boolean, isDisplayDeliveryUnits: boolean, isDisplayCallTypes: boolean, isDisplayServiceTime: boolean, isDisplayDeliveryDays: boolean};
  @Output() onFetchNext = new EventEmitter<null>();
  @Output() onDeleteCalls = new EventEmitter<{ deletedCallIds: string[], cellId: string }>();
  @Output() onUpdateVisitCellTracker = new EventEmitter<VisitPlanCellModel>();
  @Output() onUpdateCallsTimeWindow = new EventEmitter<{
    list: { callId: string, notBefore: number, notAfter: number }[],
    cellId: string
  }>();
  @Output() onAddCall = new EventEmitter<{ cellId: string, date: number, account: any }>();
  @Output() onAdvanceEditCall = new EventEmitter<{
    cellId: string,
    call: VisitPlanCallModel,
    visitPlanCell: VisitPlanCellModel,
    account: any
  }>();
  @Output() onAssignCallsToResource = new EventEmitter<{
    callIds: string[],
    resourceId: string,
    cellId: string,
    accountId: string,
    dateRange: { from: number, to: number }
  }>();
  @Output() onUnAssignCalls = new EventEmitter<[]>();
  @Output() onFilterViewByVisitScheduleDay = new EventEmitter<VisitScheduleDayModel>();
  @Output() onLockAccountChange = new EventEmitter<{ id: string, locked: boolean }>();
  @Output() onLockCallChange = new EventEmitter<{ id: string, locked: boolean }>();
  @Output() onRemoveDeliveries = new EventEmitter<{
    accountId?: string,
    accountName?: string,
    deliveriesCount?: number,
    from?: number,
    to?: number
  }>();
  @Output() onRemoveCalls = new EventEmitter<{from: number, to: number}>();
  @Output() onOpenAccountInfo = new EventEmitter<{account: VisitPlanAccountModel}>();


  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public readonly skeletonRows: undefined[] = Array.from({length: 10});
  public readonly skeletonDayColumns: undefined[] = Array.from({length: 7});

  public tableDays: { dayName: string; date: string }[] = [];
  public hoveredDayId: string | null = null;
  private isResizing = false;
  private isResizeHandleBound = false;
  private startX = 0;
  private startWidth = 0;

  private onMouseMoveBound!: (event: MouseEvent | TouchEvent) => void;
  private onMouseUpBound!: (event: MouseEvent | TouchEvent) => void;
  public onWindowResizeBound: any;

  public totalsColumnWidth: number = 460;
  public totalsData: { [key: string]: number } = {};
  public totalsInitialData: { [key: string]: number } = {};
  public visitPlanAccountsAnalysisMap: { [key: string]: VisitPlanAccountAnalysisModel } = {};
  public dispatchedDayMap: { [key: string]: boolean } = {};

  readonly DEFAULT_DAY_COL_WIDTH = 275;
  public dayColWidth: number = 275;
  public windowSize = window.innerWidth;
  private scrollSub?: () => void; // or store handler ref

  @HostListener('window:resize', ['$event'])
  onResize(event: UIEvent): void {
    this.windowSize = (event.target as Window).innerWidth;
    this.setDayColumnWidth();
    this.alignScrollbar();
  }


  constructor(@Inject(ElementRef) private elRef: ElementRef, @Inject('splitService') private splitService,
              @Inject(Renderer2) private renderer: Renderer2, @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.tableDays = this.generateTableDays();

    // Bind context for event handlers
    this.onMouseMoveBound = this.onMouseMove.bind(this);
    this.onMouseUpBound = this.onMouseUp.bind(this);

    // Add window resize listener
    this.onWindowResizeBound = this.setTotalsWidth.bind(this);
    window.addEventListener('resize', this.onWindowResizeBound);

    // Initial width check (wait until next tick to ensure rendering)
    // setTimeout(() => this.setTotalsWidth(), 0);

    // Add document mouseup/touchend listeners
    document.addEventListener('mouseup', this.onMouseUpBound);
    document.addEventListener('touchend', this.onMouseUpBound);
  }

  ngDoCheck() {
    // this.cdkVirtualScrollViewport?.checkViewportSize();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.accounts) {
      this.cdkVirtualScrollViewport?.checkViewportSize();
      setTimeout(() => {
        this._initTableScroll();
      })

    }

    if (changes.visitPlanDayTotals || changes.visitPlanInitialDayTotals) {
      setTimeout(() => {
        this._initTableScroll();
      })

      this._initTotalsData();
    }

    if ((changes.from && !changes.from.isFirstChange()) ||
      (changes.to && !changes.to.isFirstChange())) {
      this.tableDays = this.generateTableDays();
    }

    if (changes.visitPlanAccountsAnalysis) {
      this.visitPlanAccountsAnalysisMap = {};
      this.visitPlanAccountsAnalysis?.forEach(accountAnalysis => {
        this.visitPlanAccountsAnalysisMap[accountAnalysis.accountId] = accountAnalysis;
      })
    }

    if (changes.visitScheduleDays) {
      this._setDispatchedDayMap();

      setTimeout(() => {
        this.setTotalsWidth();
        this.setDayColumnWidth();
      }, 0);
    }

    if (changes.tableFilterColumns) {
      setTimeout(() => {
        this.setTotalsWidth();
        this.setDayColumnWidth();
      }, 0);
    }

    if (changes.isInitialized) {
      if (this.isInitialized) {
        setTimeout(() => {
          this._initTableScroll();
          this.setDayColumnWidth();
          this._bindResizeHandle();
        });
      } else {
        // The real table (and its .resize-handle) is destroyed while the skeleton is shown,
        // so the listeners bound to it are gone too - allow re-binding once it comes back.
        this.isResizeHandleBound = false;
      }
    }
  }

  ngAfterViewInit(): void {
    this._initTableScroll();
    this.setDayColumnWidth();
    this._bindResizeHandle();
  }

  private _bindResizeHandle(): void {
    if (this.isResizeHandleBound) return;

    const handle = this.elRef.nativeElement.querySelector('.resize-handle');
    if (!handle) return;

    this.isResizeHandleBound = true;
    handle.addEventListener('mousedown', this.startResize.bind(this));
    handle.addEventListener('touchstart', this.startResize.bind(this), {
      passive: false,
    });
  }

  ngOnDestroy(): void {
    // Remove all global listeners
    document.removeEventListener('mousemove', this.onMouseMoveBound);
    document.removeEventListener('touchmove', this.onMouseMoveBound);
    document.removeEventListener('mouseup', this.onMouseUpBound);
    document.removeEventListener('touchend', this.onMouseUpBound);
    window.removeEventListener('resize', this.onWindowResizeBound);

    this.scrollSub?.();
  }

  onRemoveDeliveriesByDay(date) {
    const from = moment(date).startOf('day').valueOf();
    const to = moment(date).startOf('day').valueOf();

    this.onRemoveDeliveries.emit({from: from, to: to});
  }

  onRemoveCallsByDay(date) {
    const from = moment(date).startOf('day').valueOf();
    const to = moment(date).endOf('day').valueOf();

    this.onRemoveCalls.emit({from: from, to: to});
  }

  getBlockedDayTooltipKey(dayId: string): string {
    return this.dispatchedDayMap[dayId] ? 'VISIT_SCHEDULE_TOOLTIPS.DAY_BLOCKED_DISPATCHED' : '';
  }

  private _setDispatchedDayMap() {
    this.dispatchedDayMap = {};
    this.visitScheduleDays?.forEach(day => {
      this.dispatchedDayMap[day.id] = isVisitScheduleDayDispatched(day);
    });
  }

  startResize(event: MouseEvent | TouchEvent): void {
    event.preventDefault();

    const handle = event.target as HTMLElement;
    handle.classList.add('active');

    this.isResizing = true;

    const e = event instanceof TouchEvent ? event.touches[0] : event;
    this.startX = e.clientX;

    // Get the first sticky (they all have same initial width)
    const stickies = this.elRef.nativeElement.querySelectorAll('.sticky') as NodeListOf<HTMLElement>;
    if (!stickies.length) return;

    this.startWidth = stickies[0].offsetWidth;

    document.addEventListener('mousemove', this.onMouseMoveBound);
    document.addEventListener('touchmove', this.onMouseMoveBound);
  }

  onMouseMove(event: MouseEvent | TouchEvent): void {
    if (!this.isResizing) return;

    const e = event instanceof TouchEvent ? event.touches[0] : event;
    const dx = e.clientX - this.startX;
    const newWidth = this.startWidth + dx;

    if (newWidth >= 200) {
      const stickies = this.elRef.nativeElement.querySelectorAll('.sticky') as NodeListOf<HTMLElement>;
      stickies.forEach((sticky) => {
        sticky.style.width = `${newWidth}px`;
        sticky.style.minWidth = `${newWidth}px`;
        sticky.style.maxWidth = `${newWidth}px`;
      });

      this.setTotalsWidth(newWidth);
    }
  }

  onMouseUp(): void {
    if (!this.isResizing) return;

    const handle = this.elRef.nativeElement.querySelector('.resize-handle');
    handle?.classList.remove('active');

    this.isResizing = false;

    document.removeEventListener('mousemove', this.onMouseMoveBound);
    document.removeEventListener('touchmove', this.onMouseMoveBound);

    // Save the final width from one of the sticky elements
    const sticky = this.elRef.nativeElement.querySelector('.sticky') as HTMLElement;
    const finalWidth = sticky?.offsetWidth ?? this.totalsColumnWidth;
    this.setTotalsWidth(finalWidth);
  }

  setTotalsWidth(width?: number): void {
    const sticky = this.elRef.nativeElement.querySelector('.sticky') as HTMLElement;
    this.totalsColumnWidth = width || sticky?.offsetWidth || this.totalsColumnWidth;
    this.setDayColumnWidth();
  }

  getNextBatch() {
    if (this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 50) {
      this.onFetchNext.emit();
    }
  }


  generateTableDays() {
    const days: { dayName: string; date: string }[] = [];

    const format = this.splitService.getDateAndTimeConfig(false).fullDate;

    let current = moment(this.from).startOf('day');
    const end = moment(this.to).startOf('day');
    while (current.isSameOrBefore(end, 'day')) {
      days.push({
        dayName: current.format('dddd'),
        date: current.format(format),
      });

      current = current.clone().add(1, 'day');
    }

    return days;
  }


  setDayColumnWidth() {
    if (!this.visitScheduleDays || !this.visitScheduleDays.length) return;

    const previousWidth = this.dayColWidth;

    let columnsEnabledCount = 0;
    _.forOwn(this.tableFilterColumns, (value, key) => {
      if (!!value) {
        columnsEnabledCount++;
      }
    })

    if (this.visitScheduleDays.length > 3 && columnsEnabledCount >= 4) {


      this.dayColWidth = this.DEFAULT_DAY_COL_WIDTH;
    } else {
      this.dayColWidth = (this.windowSize - this.totalsColumnWidth) / this.visitScheduleDays.length;
    }

    // Only trigger change detection if the width actually changed
    if (previousWidth !== this.dayColWidth) {
      this.cdr.detectChanges();
    }
  }

  private _initTotalsData() {
    this.totalsData = {
      totalServiceTime: 0,
      totalDeliveryUnits: 0,
      totalDeliveryDays: 0,
      merchandise: 0,
      orders: 0,
      sells: 0,
      totalAccounts: this.visitPlanDayTotals && this.visitPlanDayTotals?.length > 0
        ? this.visitPlanDayTotals[0].totalSlots
        : 0
    };

    this.visitPlanDayTotals?.forEach(d => {
      this.totalsData.totalServiceTime += d.destinationServiceTime;
      this.totalsData.totalDeliveryUnits += d.deliveryUnits;
      this.totalsData.totalDeliveryDays += d.deliveryDays || 0;

      for (const [id, value] of Object.entries(d.programTypes)) {
        if (this.programTypeAliasMap[id] === 'M') {
          this.totalsData.merchandise += value;
        }

        if (this.programTypeAliasMap[id] === 'O') {
          this.totalsData.orders += value;
        }

        if (this.programTypeAliasMap[id] === 'S') {
          this.totalsData.sells += value;
        }
      }
    })


    // INIT - Initial Totals Data.
    this.totalsInitialData = {
      totalServiceTime: 0,
      totalDeliveryUnits: 0,
      totalDeliveryDays: 0,
      merchandise: 0,
      orders: 0,
      sells: 0,
      totalAccounts: this.visitPlanInitialDayTotals && this.visitPlanInitialDayTotals?.length > 0
        ? this.visitPlanInitialDayTotals[0].totalSlots
        : 0
    };

    this.visitPlanInitialDayTotals?.forEach(d => {
      this.totalsInitialData.totalServiceTime += d.destinationServiceTime;
      this.totalsInitialData.totalDeliveryUnits += d.deliveryUnits;
      this.totalsInitialData.totalDeliveryDays += d.deliveryDays || 0;

      for (const [id, value] of Object.entries(d.programTypes)) {
        if (this.programTypeAliasMap[id] === 'M') {
          this.totalsInitialData.merchandise += value;
        }

        if (this.programTypeAliasMap[id] === 'O') {
          this.totalsInitialData.orders += value;
        }

        if (this.programTypeAliasMap[id] === 'S') {
          this.totalsInitialData.sells += value;
        }
      }
    })

  }

  private _initTableScroll() {
    const headerOne = this.elRef.nativeElement.querySelector('#header-one');
    const headerTwo = this.elRef.nativeElement.querySelector('#header-two');
    const footer = this.elRef.nativeElement.querySelector('#footer');

    const viewportEl = this.cdkVirtualScrollViewport?.elementRef?.nativeElement as HTMLElement;
    if (!viewportEl) {
      return;
    }

    // Remove previous listener if you re-init
    if (this.scrollSub) {
      this.scrollSub();
      this.scrollSub = undefined;
    }

    // Force overflow-x: auto on headers and footer to allow horizontal scroll sync
    // We must use 'important' to override the global CSS which has overflow: hidden !important
    if (headerOne) {
      headerOne.style.setProperty('overflow-x', 'auto', 'important');
      headerOne.style.setProperty('overflow-y', 'hidden', 'important');

      // Hide scrollbar but keep functionality
      (headerOne.style as any).scrollbarWidth = 'none';
      (headerOne.style as any).msOverflowStyle = 'none';
    }
    if (headerTwo) {
      headerTwo.style.setProperty('overflow-x', 'auto', 'important');
      headerTwo.style.setProperty('overflow-y', 'hidden', 'important');

      (headerTwo.style as any).scrollbarWidth = 'none';
      (headerTwo.style as any).msOverflowStyle = 'none';
    }
    if (footer) {
      footer.style.setProperty('overflow-x', 'auto', 'important');
      footer.style.setProperty('overflow-y', 'hidden', 'important');

      (footer.style as any).scrollbarWidth = 'none';
      (footer.style as any).msOverflowStyle = 'none';
    }

    // Bi-directional scroll sync
    const syncScroll = (source: HTMLElement, targets: (HTMLElement | null)[]) => {
      const scrollLeft = source.scrollLeft;
      targets.forEach(target => {
        if (target && target.scrollLeft !== scrollLeft) {
          target.scrollLeft = scrollLeft;
        }
      });
    };

    const handlers: (() => void)[] = [];

    const viewportHandler = () => syncScroll(viewportEl, [headerOne, headerTwo, footer]);
    viewportEl.addEventListener('scroll', viewportHandler, { passive: true });
    handlers.push(() => viewportEl.removeEventListener('scroll', viewportHandler));

    if (headerOne) {
      const headerOneHandler = () => syncScroll(headerOne, [viewportEl, headerTwo, footer]);
      headerOne.addEventListener('scroll', headerOneHandler, { passive: true });
      handlers.push(() => headerOne.removeEventListener('scroll', headerOneHandler));
    }
    if (headerTwo) {
      const headerTwoHandler = () => syncScroll(headerTwo, [viewportEl, headerOne, footer]);
      headerTwo.addEventListener('scroll', headerTwoHandler, { passive: true });
      handlers.push(() => headerTwo.removeEventListener('scroll', headerTwoHandler));
    }
    if (footer) {
      const footerHandler = () => syncScroll(footer, [viewportEl, headerOne, headerTwo]);
      footer.addEventListener('scroll', footerHandler, { passive: true });
      handlers.push(() => footer.removeEventListener('scroll', footerHandler));
    }

    // Store cleanup for all handlers
    this.scrollSub = () => handlers.forEach(cleanup => cleanup());

    this.alignScrollbar();
    this.cdkVirtualScrollViewport.checkViewportSize();
  }

  private alignScrollbar() {
    const viewport = this.elRef.nativeElement.querySelector('.cdk-virtual-scroll-viewport') as HTMLElement;
    const headerOne = this.elRef.nativeElement.querySelector('#header-one') as HTMLElement;
    const headerTwo = this.elRef.nativeElement.querySelector('#header-two') as HTMLElement;
    const footer = this.elRef.nativeElement.querySelector('#footer') as HTMLElement;

    if (!viewport) return;

    // Calculate scrollbar width (will be 0 for overlay scrollbars or if no scrolling needed)
    const scrollbarWidth = viewport.offsetWidth - viewport.clientWidth;
    const paddingRight = `${scrollbarWidth}px`;

    // Apply padding to compensate for viewport scrollbar
    if (headerOne) headerOne.style.paddingRight = paddingRight;
    if (headerTwo) headerTwo.style.paddingRight = paddingRight;
    if (footer) footer.style.paddingRight = paddingRight;
  }


}
